import * as types from "./types";

export const OrderInitialState = {
  //post request of Order
  orderMessage: null,
  orderData: null,
  successState: false,
  orderPostLoading: false,
  orderPostError: false,
  orderPostErrorMessage: null,

  orderIdToDelete: "",
  orderList: [],
  orderGetLoading: false,
  orderGetError: null,

  servedPopUp: false,

  //post serve me for user
  OrderServed: [],
  servePostLoading: false,
  servePostError: null,

  //All ORDER OF THE DAY
  allOrder: [],
  allOrderLoading: false,
  allOrderError: null,

  orderIds: [] as string[],
  totalOfServeMe: [] as string[],
  totalForServe: 0,

  //API RECALL
  apiAgain: false,

  //API RECALL FOR ORDER
  apiOrderAgain: false,
};

export const orderReducer = (state = OrderInitialState, action: any) => {
  switch (action.type) {
    case types.DELETE_ORDER_GET_ID:
      return {
        ...state,
        orderIdToDelete: action.orderId,
      };

    case types.RESET_ALL_TOTAL_AMOUNT:
      return {
        ...state,
        totalOfServeMe: [],
      };

    case types.RESET_ALL_ORDER_ID:
      return {
        ...state,
        orderIds: [],
      };

    case types.RECALL_API:
      return {
        ...state,
        apiAgain: !state.apiAgain,
      };

    case types.RECALL_ORDER_API:
      return {
        ...state,
        apiOrderAgain: !state.apiOrderAgain,
      };

    case types.STORE_ALL_TOTAL_AMOUNT:
      return {
        ...state,
        totalOfServeMe: [...state.totalOfServeMe, action.amount],
      };

    case types.SHOW_ALL_TOTAL_AMOUNT:
      const reducedTotalShow = state.totalOfServeMe?.reduce(
        (previousValue, currentValue) => previousValue + currentValue
      );
      const newTotalShow = parseFloat(reducedTotalShow);
      return {
        ...state,
        totalForServe: newTotalShow,
      };

    case types.REMOVE_THE_TOTAL_AMOUNT:
      const reducedTotal = state.totalOfServeMe?.reduce(
        (previousValue, currentValue) => previousValue + currentValue
      );
      const newTotal = parseFloat(reducedTotal) - action.amount;
      return {
        ...state,
        totalForServe: newTotal,
      };

    case types.STORE_ALL_ORDER_ID:
      const includeOrderIds = state.orderIds.includes(action.orderId);

      if (includeOrderIds) {
        return {
          ...state,
          orderIds: [...state.orderIds],
        };
      }
      return {
        ...state,
        orderIds: [...state.orderIds, action.orderId],
      };

    case types.STORE_ORDER_ID:
      return {
        ...state,
        orderIds: [...state.orderIds, action.orderId],
      };

    case types.REMOVE_ORDER_ID:
      const newOrderCopy = [...state.orderIds];
      // console.log(newOrderCopy);
      const orderToSet = newOrderCopy.filter((item) => item !== action.orderId);
      // console.log("newOrder", orderToSet);
      return {
        ...state,
        orderIds: orderToSet,
      };

    case types.GET_ALL_ORDER_START:
      return {
        ...state,
        allOrderLoading: true,
      };

    case types.GET_ALL_ORDER_SUCESS:
      return {
        ...state,
        allOrderLoading: false,
        allOrder: action.allOrder,
      };

    case types.GET_ALL_ORDER_FAILURE:
      return {
        ...state,
        allOrderLoading: false,
        allOrderError: action.allOrderError,
      };

    case types.POST_SERVE_START:
      return {
        ...state,
        servePostLoading: true,
      };
    case types.POST_SERVE_SUCESS:
      return {
        ...state,
        servePostLoading: false,
        OrderServed: action.OrderServed,
      };
    case types.POST_SERVE_FAILURE:
      return {
        ...state,
        servePostError: action.servePostError,
        servePostLoading: false,
      };

    case types.POST_ORDER_START:
      return {
        ...state,
        orderPostLoading: true,
      };
    case types.POST_ORDER_SUCESS:
      // console.log("i m in order success");
      return {
        ...state,
        orderPostLoading: false,
        orderMessage: action.orderMessage,
        orderData: action.orderData,
        successState: action.orderData.length !== 0,
      };

    case types.POST_ORDER_FAILURE:
      return {
        ...state,
        orderPostError: action.orderPostError,
        orderPostLoading: false,
        orderPostErrorMessage: action.orderPostErrorMessage,
      };

    case types.CANCLE_PUNCH_IN_MESSAGE:
      return {
        ...state,
        orderPostError: !state.orderPostError,
        orderPostLoading: false,
        orderPostErrorMessage: "",
      };

    case types.CANCLE_ORDER_MESSAGE:
      return {
        ...state,
        successState: !state.successState,
        orderMessage: null,
        orderData: null,
      };

    case types.SHOW_SERVED_MESSAGE:
      return {
        ...state,
        servedPopUp: true,
      };

    case types.CANCLE_SERVED_MESSAGE:
      return {
        ...state,
        servedPopUp: false,
        // orderMessage: null,
        OrderServed: null,
      };

    case types.GET_ORDER_START:
      return {
        ...state,
        orderGetLoading: true,
      };

    case types.GET_ORDER_SUCCESS:
      return {
        ...state,
        orderList: action.orderList,
        orderGetLoading: false,
      };

    case types.GET_ORDER_FAILURE:
      return {
        ...state,
        orderGetLoading: false,
        orderGetError: action.orderGetError,
      };

    default:
      return state;
  }
};
